(function ($) {
	'use strict';

	$(function () {
		[...document.querySelectorAll('.js-audio')].forEach(audioSystem => {
			const button = audioSystem.querySelector('.js-audio-button');
			const player = audioSystem.querySelector('.js-audio-player');
			const buttonCircle = button.querySelector('.js-audio-button-circle');
			const buttonText = button.querySelector('.js-audio-button-text');

			let isPlaying = false;

			button.addEventListener('click', ev => {
				if (isPlaying === false) {
					player.play();
				} else {
					player.pause();
				}
			});

			player.addEventListener('play', () => {
				isPlaying = true;
				button.classList.add('audio__button--playing');
				buttonText.textContent = 'Pause audio';
			});

			player.addEventListener('pause', () => {
				isPlaying = false;
				button.classList.remove('audio__button--playing');
				buttonText.textContent = 'Play audio';
			});

			player.addEventListener('ended', () => {
				isPlaying = false;
				button.classList.remove('audio__button--playing');
				buttonText.textContent = 'Play audio';
				player.pause();
				player.currentTime = 0;
			});
		});
	});
})(jQuery);
